exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".WishLists-root-lge34 {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.WishLists-container-vK9Ml {\n  margin: 0px auto;\n  padding-top: 30px;\n  max-width: 1400px;\n  padding-bottom: 50px;\n}\n\n@media screen and (max-width: 1200px) {\n  .WishLists-mainSection-cEBZO {\n    margin-bottom: 60px;\n    margin-top: 30px;\n  }\n\n  .WishLists-container-vK9Ml {\n    padding-top: 75px;\n  }\n}", ""]);

// exports
exports.locals = {
	"root": "WishLists-root-lge34",
	"container": "WishLists-container-vK9Ml",
	"mainSection": "WishLists-mainSection-cEBZO"
};